 const sendForm = () => {
    const formBtn = document.querySelector('#send')
    let trigger = '.toggle';
    let height = 'auto';
    if(window.innerWidth <= 768) {
        trigger = '.contact-us__form-wrapper.mobile-trigger';
        height = 100;
    }
    let toggleBlock = gsap.to(trigger, {
        height: height,
        paused: true,
        autoAlpha: 1,
        duration: 1.5,
        ease: 'power1.out'
    })
    const descrBlocks = document.querySelectorAll('.contact-us__description>p');
        formBtn.addEventListener('click', async function (event) {
        event.preventDefault();

        let response = await fetch("/mailer/mail.php", {
            method: "POST",
            body: new FormData(form),
        });
        toggleBlock.play()
        if (response.ok) {
            descrBlocks[1].classList.add('success');
        } else {
            descrBlocks[0].classList.add('error');
        }
        form.reset(); 
        formBtn.setAttribute('disabled', true);
        setTimeout(() => {
            toggleBlock.reverse();
        }, 3000);
    });
}

export default sendForm;